const isValidEmail = (email: string): boolean => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

const validation = {
  email: isValidEmail,
};

window.aguadecoco = window.aguadecoco || {};

Object.assign(window.aguadecoco, {
  helpers: Object.assign(window.aguadecoco.helpers || {}, { validation }),
});

export default {};
